import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios, { CancelToken, isCancel } from 'axios';
import FetchError from '../FetchError';
import Loading from '../Loading';


class TabFetchProvider extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            shouldFetch: true,
            errorTimeout: null
        };
    }

    componentDidMount() {
        this.fetchData(this.props.params);
    }

    componentWillReceiveProps({ params }) {
        const { id, tab } = this.props.params;
        if (id === params.id && tab === params.tab) return;

        this.cancelRequest();
        this.setState({ shouldFetch: true, data: {} });

        this.fetchData(params);
    }

    cancelRequest = () => null

    fetchData({ id, name, tab, type }) {
        const indexTab = this.props.route.fetchPath || '';

        axios.get(`tab/${type}/${id}/${name}/${tab || indexTab}`, {
            cancelToken: new CancelToken((cancel) => {
                this.cancelRequest = cancel;
            })
        }).then(({ data }) => {
            this.setState({ shouldFetch: false, data });
        }).catch((error) => {
            if (isCancel(error)) return;

            console.warn(error);
            this.setState({
                errorTimeout: setTimeout(this.refresh, 20000)
            });
        });
    }

    refresh = () => {
        clearTimeout(this.state.errorTimeout);
        this.setState({
            errorTimeout: null
        });
        this.fetchData(this.props.params);
    }

    render() {
        const { shouldFetch, data: fetchedData, errorTimeout } = this.state;
        const {
            route: { Tab }, params, data
        } = this.props;

        return shouldFetch ? (
            <section>
                <Loading />
                {errorTimeout && <FetchError refresh={this.refresh} />}
            </section>
        ) : (
            <Tab data={Object.assign({}, data, fetchedData)} params={params} />
        );
    }
}

TabFetchProvider.propTypes = {
    route: PropTypes.shape({
        Tab: PropTypes.func.isRequired,
        fetchPath: PropTypes.string.isRequired
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string
    }).isRequired,
    data: PropTypes.shape({})
};

export default TabFetchProvider;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/providers/TabFetchProvider.jsx